(function () {
  function getYoutubeEmbedHtml(url) {
    var match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (!match) return null;
    return (
      '<iframe src="https://www.youtube.com/embed/' + match[1] + '?autoplay=1" ' +
      'frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>'
    );
  }

  function initSection(root) {
    if (!root || root.dataset.iovInit === 'true') return;
    root.dataset.iovInit = 'true';

    var trigger = root.querySelector('[data-video-trigger]');
    var modal = root.querySelector('[data-video-modal]');
    var player = root.querySelector('[data-video-player]');
    var closeEls = root.querySelectorAll('[data-video-close]');

    if (!trigger || !modal || !player) return;

    function openModal() {
      var url = trigger.getAttribute('data-video-url');
      var embedHtml = getYoutubeEmbedHtml(url);
      if (!embedHtml) return;
      player.innerHTML = embedHtml;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      player.innerHTML = '';
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openModal);
    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.image-overlay-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.image-overlay-section');
    if (root) initSection(root);
  });
})();